<template>
  <div v-for="file in dataSource" :key="file.id">
    <div
      :class="['file-item', file.type === getAudioType().ARTICLE ? 'audio-item' : 'irc-item']"
      v-if="(isFilter && file.lrcStatus === 0 && file.type === getAudioType().ARTICLE) || !isFilter"
    >
      <div class="icon irc-icon" v-if="file.type !== getAudioType().ARTICLE"></div>
      <div class="icon audio-icon" v-else-if="file.isVideo === 0"></div>
      <div class="icon video-icon" v-else></div>
      <div class="title">{{ file.title }}</div>
      <div
        :class="[
          'has-task',
          file.taskKey && file.type === getAudioType().ARTICLE ? 'has-task-true' : '',
        ]"
      >
        <div v-show="file.taskKey && file.type === getAudioType().ARTICLE">已存在任务</div>
      </div>
      <div
        :class="['check-btn', getIsFileChecked(file.articleKey) ? 'checked' : '']"
        v-show="file.type === getAudioType().ARTICLE"
        @click="checkFile(file)"
      />
    </div>
  </div>
</template>
<script>
import { getAudioType } from '../../../../controller/config';

export default {
  props: {
    dataSource: Array,
    column: Object,
    isFilter: Boolean,
    checkedList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['checkFile'],
  setup(props, context) {
    function getIsFileChecked(articleKey) {
      return props.checkedList.indexOf(articleKey) > -1;
    }
    function checkFile(file) {
      return context.emit('checkFile', file);
    }
    return {
      getAudioType,
      getIsFileChecked,
      checkFile,
    };
  },
};
</script>
